export const CHANGE_PASSWORD_INITIAL = 'CHANGE_PASSWORD_INITIAL';
export const CHANGE_PASSWORD_SUCESS = 'CHANGE_PASSWORD_SUCESS';
